import {Badge, Button, IconButton, Menu, MenuHandler, MenuItem, MenuList, Typography,} from "@material-tailwind/react";
import {BsClock, BsEnvelope, BsEnvelopeOpen} from "react-icons/bs";
import {useContext, useEffect, useState} from "react";
import {getNotifications, updateNotificationRead} from "../../services/notification/notification";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {UpdateHeaderContext} from "../../context/update_header";

export function NotificationsMenu({onClick}) {

  const [messages, setMessages] = useState([])
  const [lastDataRefresh, setLastDataRefresh] = useState(Date.now())

  const {updateNotifications} = useContext(UpdateHeaderContext)

  useEffect(() => {
    async function getData() {
      const result = await getNotifications();
      if (result.status === 200) {
        const {notificationList} = result.data;
        setMessages(notificationList || []);
      }
    }

    getData()
  }, [lastDataRefresh, updateNotifications]);

  const notificationRead = async (id) => {
    const data = {
      id: id,
    };
    let result;

    result = await updateNotificationRead(data);

    if (result.status === 200) {
      setLastDataRefresh(Date.now())
    }
  };


  return (
    <Badge
      content={(messages && persianNumberFormat(messages.filter(obj => obj.push_status === 'unread').length)) || 0}>
      <Menu>
        <MenuHandler>
          <IconButton variant="outlined">
            <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
              <path fillRule="evenodd"
                    d="M5.25 9a6.75 6.75 0 0113.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 11-7.48 0 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 104.496 0 25.057 25.057 0 01-4.496 0z"
                    clipRule="evenodd"/>
            </svg>
          </IconButton>
        </MenuHandler>
        <MenuList className="flex flex-col gap-2 px-4 mx-4 py-8">
          {
            messages.slice(0, 5).map((msg, idx) => (
              <MenuItem key={idx} className="flex items-center gap-4 py-2 pl-2 pr-4 border-b" onClick={() => {
                if (msg.push_status === 'unread') {
                  notificationRead(msg.id)
                }
                onClick('notifications')
                localStorage.setItem("selectedNotification", msg.id)
              }}>
                {/*<BsEnvelope size={25} className="gap-1 text-blue-gray-700"/>*/}
                {msg.push_status === 'unread' &&
                  <BsEnvelope size={30}/>
                }
                {msg.push_status === 'read' &&
                  <BsEnvelopeOpen size={30}/>}
                <div className="flex flex-col gap-1">
                  <Typography variant="small" color="gray" className="font-semibold">
                    {msg.title}
                  </Typography>
                  <Typography className="flex items-center justify-center gap-1 text-sm font-medum text-blue-gray-400">
                    <BsClock/>
                    <span
                      className="mt-1">{persianNumberFormat(msg.create_date.split(" ")[1] + " " + msg.create_date.split(" ")[0])}</span>
                  </Typography>
                </div>
              </MenuItem>
            ))

          }

          <MenuItem className="flex items-center gap-4 mt-4">
            <Button variant="gradient" onClick={() => onClick("notifications")} className="w-full">
              صفحه پیام‌ها
            </Button>
          </MenuItem>
        </MenuList>
      </Menu>
    </Badge>
  );
}